import { configureStore } from "@reduxjs/toolkit";
import sessionReducer from "./sessionSlice";  // Assuming sessionSlice is the correct file
import eventReducer from "./reducers/eventreducers";  // Fixing the import statement

const store = configureStore({
  reducer: {
    session: sessionReducer,
    events: eventReducer,  // Adding the eventReducer here
  },
});

export default store;
